import { sendRequest } from "./sendRequest";

export const readNotifications = () => {
  return sendRequest("put", `/influencer/me/read-all-notifications`, {}).then(
    (res) => res.data
  );
};
